module.exports = __webpack_public_path__ + "static/NotoSans-Bold-6a1f7cfe6252b44b6ea1e3fbf5b6661b.ttf";